import { publicHref } from '../lib/publicUrls';
import { ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const WEEKLY_SCHEDULE_URL = 'https://agency-common-ui.pages.dev/ca_deltavac/groupex/calendar';
const OFFICIAL_SCHEDULE_URL = 'https://deltavac.clubautomation.com/calendar/classes?tab=by-class';

const LiveScheduleEmbed = ({
  categoryId,
  title = 'Delta Valley Health Club weekly class schedule',
  heightClass = 'h-[1150px] md:h-[1250px]',
}) => {
  const scheduleUrl = categoryId
    ? `${WEEKLY_SCHEDULE_URL}?category=${categoryId}`
    : WEEKLY_SCHEDULE_URL;

  return (
    <div className="space-y-4" data-testid="live-schedule-embed">
      <div className="flex flex-col gap-3 rounded-xl border border-blue-100 bg-blue-50 px-5 py-4 text-sm text-gray-700 sm:flex-row sm:items-center sm:justify-between">
        <p className="dv-size-body">
          Class times update live from Delta Valley&apos;s scheduling system. Use the filters to narrow by activity, club, time, or instructor.
        </p>
        <a href={publicHref(OFFICIAL_SCHEDULE_URL)} target="_blank" rel="noopener noreferrer" className="shrink-0">
          <Button variant="outline" size="sm" className="bg-white">
            Open Official Schedule <ExternalLink className="ml-2" size={15} />
          </Button>
        </a>
      </div>

      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        {/* The provider fixes its accent to brown (#9B6E18) and offers no color option. The calendar
            is otherwise white and gray, so a hue shift turns only the accent to the site's blue. */}
        <iframe
          src={scheduleUrl}
          title={title}
          className={`w-full ${heightClass} bg-white`}
          style={{ filter: 'hue-rotate(160deg)' }}
          loading="eager"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    </div>
  );
};

export { OFFICIAL_SCHEDULE_URL, WEEKLY_SCHEDULE_URL };
export default LiveScheduleEmbed;
